import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Menu = _resolveComponent("Menu");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_alert = _resolveComponent("el-alert");
  const _component_el_row = _resolveComponent("el-row");
  const _component_SubjectCard = _resolveComponent("SubjectCard");
  return _openBlock(), _createBlock(_component_el_row, {
    class: "DashboardViewContainer"
  }, {
    default: _withCtx(() => [$data.menus.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "mt32"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 6,
        class: "flex flex-col brd3",
        style: {
          "background-color": "#F1F3F7"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu, {
          "default-openeds": [0, 1, 2],
          "default-active": "0-0",
          "background-color": "#F1F3F7",
          class: "el-menu-vertical-demo"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menus, (m, mi) => {
            return _openBlock(), _createBlock(_component_el_sub_menu, {
              key: mi,
              index: mi
            }, {
              title: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Menu)]),
                _: 1
              }), _createElementVNode("span", null, _toDisplayString(m.name), 1)]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.sub, (s, si) => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  key: 'sub_' + si,
                  index: `${mi}-${si}`,
                  onClick: $event => $options.onTabClick(s.name, mi, si, s.desc)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(s.name), 1)]),
                  _: 2
                }, 1032, ["index", "onClick"]);
              }), 128))]),
              _: 2
            }, 1032, ["index"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 18,
        style: {
          "padding-left": "10px"
        }
      }, {
        default: _withCtx(() => [_ctx.dashboard.desc ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_alert, {
            title: _ctx.dashboard.desc,
            type: "warning"
          }, null, 8, ["title"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menus[_ctx.dashboard.tabIndex].sub[_ctx.dashboard.subIndex].subjects, (s, si) => {
            return _openBlock(), _createBlock(_component_el_col, {
              span: 8,
              class: "flex items-center justify-center",
              key: s.subject
            }, {
              default: _withCtx(() => [_createVNode(_component_SubjectCard, {
                data: s,
                index: si
              }, null, 8, ["data", "index"])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  });
}